<ng-select
  [items]="companies$ | async"
  placeholder="{{ 'companyselect.placeholder' | translate }}"
  [searchable]="true"
  [clearable]="false"
  [(ngModel)]="selectedCompany"
  (change)="selectionChange.emit($event)"
  [virtualScroll]="true"
  [loading]="companiesLoading"
  [minTermLength]="minLengthTerm"
  [trackByFn]="trackByFn"
  [typeahead]="companyInput$"
  typeToSearchText="{{ 'companyselect.minlength' | translate: { value: minLengthTerm } }}"
  [ngModelOptions]="{ standalone: true }"
  [class.is-invalid]="!valid"
  required>
  <ng-template
    ng-label-tmp
    let-item="item"
    let-clear="clear">
    <span class="ng-value-label">{{ item.fullName + ", " + item.name }}</span>
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm">
    <span class="ng-value-label">{{ item.fullName + ", " + item.name }}</span>
  </ng-template>
</ng-select>
